export default __webpack_public_path__ + "static/media/table5seatUnilateral.a78054b8.svg";